module.exports = __webpack_public_path__ + "img/Nature-text.3594850d.jpg";